module.exports = __webpack_public_path__ + "img/card1.96d6a740.png";